module.exports = __webpack_public_path__ + "img/Weapon_227.74e1f977.png";